import React from 'react';
import { Link } from 'react-router-dom';
import Search_icon from '../Images/Search_icon.png'
import PropTypes from 'prop-types'
export default function Navbar(props) {
  return (
    <div className={props.mode}>
      <div className="navbar">
        <ul>
          <Link className='list' to = '/'> <li>Home</li></Link>
          <Link className='list' to = '/about'> <li>About Us</li></Link>
          <Link className='list' to = '/contact'> <li>Contact Us</li></Link>
         
        </ul>
        <div className="searchbar">
          <div className="searchinput">
            <img src={Search_icon} alt="..." />
            <input type="text" name="" id="" placeholder='Search Here' />
          </div>
          <button className='btn'>Search</button>
        </div>
        <div className="modeIcon">
          <img src={props.imgSrc} alt="" onClick={props.changeMode} />
        </div>

      </div>
    </div>
  );
}
